// Client-side public surface: what other modules may use.

import { lazyView } from "@/platform/client";

export const ArtGalleryPage = lazyView(() =>
  import("./ui/art-gallery/ArtGalleryPage.js").then((m) => m.ArtGalleryPage),
);
export { ArtworkImage } from "./ui/components/ArtworkImage.js";
export { InspirationModal } from "./ui/components/InspirationModal.js";
export { useInspirationToday } from "./ui/queries/inspiration.js";
